import * as React from 'react';
import Icon from '../../../../icons/Icon';

export default class HospitalIcon extends Icon {
    renderIcon() {
        return (
            <svg width={this.getSize()} height={this.getSize()} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0" y="0" viewBox="0 0 514 514">
                <circle cx="257" cy="257" r="257" fill="#FFFFFF"></circle>
                <g>
                    <defs>
                        <circle id="SVGID_1_" cx="257" cy="257" r="257"></circle>
                    </defs>
                    <clipPath id="SVGID_00000078756582560291087220000011422462143508552084_">
                        <use overflow="visible" xlinkHref="#SVGID_1_"></use>
                    </clipPath>
                    <g
                        fill="#4D5E80"
                        clipPath="url(#SVGID_00000078756582560291087220000011422462143508552084_)"
                    >
                        <path d="M463.626 414.328h-45.719a4.374 4.374 0 01-4.374-4.374V142.46H349.3v100.958a4.37 4.37 0 01-1.329 3.139 4.28 4.28 0 01-3.176 1.232l-18.225-.552a4.376 4.376 0 01-4.241-4.373v-51.358h-56.237a4.373 4.373 0 01-4.374-4.376v-77.746H158.425v78.214a4.375 4.375 0 01-4.375 4.374h-53.583v217.981a4.373 4.373 0 01-4.373 4.374h-45.72a4.374 4.374 0 010-8.747H91.72V187.599a4.373 4.373 0 014.373-4.375h53.584v-78.213a4.373 4.373 0 014.373-4.374h112.041a4.372 4.372 0 014.373 4.374v77.746h56.238a4.374 4.374 0 014.375 4.373v51.492l9.475.287V138.087a4.373 4.373 0 014.374-4.373h72.981a4.373 4.373 0 014.373 4.373v267.494h41.347a4.374 4.374 0 11-.001 8.747z"></path>
                        <path d="M226.197 152.64L216.271 152.64 216.271 142.719 203.047 142.719 203.047 152.64 193.121 152.64 193.121 165.864 203.047 165.864 203.047 175.784 216.271 175.784 216.271 165.864 226.197 165.864z"></path>
                        <path d="M237.769 191.739h-56.226a4.373 4.373 0 01-4.374-4.373V131.14a4.373 4.373 0 014.374-4.375h56.226a4.374 4.374 0 014.374 4.375v56.226a4.374 4.374 0 01-4.374 4.373zm-51.853-8.747h47.479v-47.479h-47.479v47.479z"></path>
                    </g>
                </g>
            </svg>
        );
    }
}